import {forwardRef, useEffect, useState} from "react";
import {
    DEFAULT_CONTENT_MIN_HEIGHT,
    DEFAULT_TAG_BACKGROUND_COLOR,
    getDefaultTagBackgroundColor,
    MAP_GROUP_BACKGROUND_COLOR
} from "../../Const";
import {getTagById} from "@model/tag";
import global from "@/global";
import {isDarkMode} from "@/utils";

const CustomPropertyTags = forwardRef((props:{item:any,arrayTags:any},ref)=>{


    useEffect(() => {

    }, []);

    return <div className={'flex-row-vertical-center'} style={{height:`${DEFAULT_CONTENT_MIN_HEIGHT}px`,gap:'0 8px'}} onClick={(e)=>{
        e.stopPropagation();
        window.showManageTags([props.item]);
    }}>
        {
            props.arrayTags.map(p=>{
                return <TagItem tagName={p}/>
            })
        }
    </div>
})

export default CustomPropertyTags;


const TagItem = forwardRef((props:{tagName:any},ref)=> {
    const [tag,setTag] = useState(null);

    /**
     * 标签文本颜色
     */
    const getTextColor = ()=>{
        let szTextColor = MAP_GROUP_BACKGROUND_COLOR[tag?.backgroundColor] || '#000000';
        if (szTextColor == '#000000' && isDarkMode()){
            szTextColor = '#FFFFFF';
        }
        return szTextColor;
    }

    useEffect(() => {
        const t = global.g_arrayTagList.find(p=>p.name == props.tagName);
        setTag(t);
    }, []);
    return <span className={'tableview-tag'} style={{background: tag?.backgroundColor || getDefaultTagBackgroundColor(),color:getTextColor()}}>{props.tagName}</span>
})